<script>
  import { getClass } from './utils'

  $: className = getClass({ className: $$props.class || '' })
</script>

<div {...$$restProps} class={className} on:click>
  <slot />
</div>
